<template>
  <v-card>
    <v-progress-linear v-if="loading" indeterminate height="2"></v-progress-linear>
    <template v-if="purchase">
      <v-card-title>
        <purchase-title :purchase="purchase"></purchase-title>
        <v-spacer></v-spacer>
        <purchase-total-price :purchase="purchase"></purchase-total-price>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-row>
        <service-meta :service="offer"></service-meta>
        <v-spacer></v-spacer>
        <date-formatter class="payed-at" :value="purchase.payed_at || purchase.created_at"></date-formatter>
      </v-card-row>
      <v-divider></v-divider>
      <v-card-text>
        <v-chip small>
          <v-avatar>
            <img :src="purchase.admin.picture.thumb">
          </v-avatar>
          <router-link :to="{ name: 'Expert', params: { id: purchase.admin.id, tab: 'profile' } }">
            {{ purchase.admin.nickname }}
          </router-link>
        </v-chip>
        <v-chip small>
          <v-avatar>
            <v-icon dark>account_circle</v-icon>
          </v-avatar>
          <router-link v-if="purchase.user" :to="{ name: 'User', params: { id: purchase.user.id, tab: 'profile' } }">
            {{ purchase.user.nickname }}
          </router-link>
        </v-chip>
      </v-card-text>
      <v-divider></v-divider>
      <component :is="component" :purchase="purchase"></component>
    </template>
    <refunded-tag v-if="isRefunded"></refunded-tag>
  </v-card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import Purchase from '@/api/purchase'
  import { Date as DateFormatter } from '@/components/formatters'
  import { ServiceMeta } from '@/components/service'
  import RefundedTag from '@/components/RefundedTag.vue'
  import {
    PurchaseTitle,
    PurchaseTotalPrice,
    PurchaseMail,
    PurchaseService,
    PurchaseCall,
    PurchaseProduct,
    PurchaseAppointment,
    PurchasePrepaidMinutes,
    PurchaseAvailability
  } from '@/components/purchase'
  export default {
    components: {
      PurchaseTitle,
      PurchaseTotalPrice,
      ServiceMeta,
      DateFormatter,
      RefundedTag
    },
    props: {
      id: {
        type: Number,
        required: true
      }
    },
    computed: {
      ...mapGetters({
        purchases: 'skiliko/purchases/collection',
        loading: 'skiliko/purchases/isLoading'
      }),
      purchase () {
        return this.purchases[this.id]
      },
      offer () {
        return this.purchase.offer
      },
      offerType () {
        return this.offer.service_type
      },
      isCall () {
        return this.offerType === 'phone'
      },
      isAppointment () {
        if (!this.isCall) { return false }
        return this.purchase.service.appointment === true
      },
      isRefunded () {
        if (!this.purchase) { return false }
        return Purchase.isRefunded(this.purchase)
      },
      component () {
        if (this.isAppointment) { return PurchaseAppointment }
        return {
          mail: PurchaseMail,
          service: PurchaseService,
          phone: PurchaseCall,
          prepaid_minute: PurchasePrepaidMinutes,
          product: PurchaseProduct,
          availability: PurchaseAvailability
        }[this.offerType]
      }
    },
    methods: mapActions(({
      fetch: 'skiliko/purchases/fetch'
    })),
    mounted () {
      this.fetch({ id: this.id })
    }
  }
</script>

<style scoped>
  .progress-linear { margin: 0; }
  .payed-at {
    width: 10em;
    margin-right: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Purchase.vue